import Login from "./Login";
module.exports = {
  path: "/farm",
  component: Login
};
